/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as TermsOfServiceImport } from './routes/terms-of-service'
import { Route as SupportImport } from './routes/support'
import { Route as PrivacyPolicyImport } from './routes/privacy-policy'
import { Route as HelpCenterImport } from './routes/help-center'
import { Route as ContactImport } from './routes/contact'
import { Route as BlogImport } from './routes/blog'
import { Route as AboutImport } from './routes/about'
import { Route as onboardingRouteImport } from './routes/(onboarding)/route'
import { Route as authRouteImport } from './routes/(auth)/route'
import { Route as appRouteImport } from './routes/(app)/route'
import { Route as IndexImport } from './routes/index'
import { Route as authTermsAndConditionsImport } from './routes/(auth)/terms-and-conditions'
import { Route as authPrivacyImport } from './routes/(auth)/privacy'
import { Route as authLoginImport } from './routes/(auth)/login'
import { Route as authGetAppImport } from './routes/(auth)/get-app'
import { Route as appDashboardIndexImport } from './routes/(app)/dashboard/index'
import { Route as onboardingStoreCreateImport } from './routes/(onboarding)/store/create'
import { Route as appuserStoreIndexImport } from './routes/(app)/(user)/store/index'
import { Route as appstoreStaffIndexImport } from './routes/(app)/(store)/staff/index'
import { Route as appstoreSettingsIndexImport } from './routes/(app)/(store)/settings/index'
import { Route as appstoreSalesIndexImport } from './routes/(app)/(store)/sales/index'
import { Route as appstoreProductIndexImport } from './routes/(app)/(store)/product/index'
import { Route as appstoreOrderIndexImport } from './routes/(app)/(store)/order/index'
import { Route as appstoreExpenseIndexImport } from './routes/(app)/(store)/expense/index'
import { Route as appstoreCustomerIndexImport } from './routes/(app)/(store)/customer/index'
import { Route as appstoreSalesCreateIndexImport } from './routes/(app)/(store)/sales/create/index'
import { Route as appstoreSalesOrderIdIndexImport } from './routes/(app)/(store)/sales/$orderId/index'
import { Route as appstoreProductAddProductIndexImport } from './routes/(app)/(store)/product/add-product/index'
import { Route as appstoreProductProductIdIndexImport } from './routes/(app)/(store)/product/$productId/index'
import { Route as appstoreOrderNewOrderIndexImport } from './routes/(app)/(store)/order/newOrder/index'
import { Route as appstoreOrderOrderIdIndexImport } from './routes/(app)/(store)/order/$orderId/index'
import { Route as appstoreExpensePurchaseIndexImport } from './routes/(app)/(store)/expense/purchase/index'
import { Route as appstoreExpenseExpenseCategoryIdIndexImport } from './routes/(app)/(store)/expense/$expenseCategoryId/index'
import { Route as appstoreCustomerAddCustomerIndexImport } from './routes/(app)/(store)/customer/add-customer/index'
import { Route as appstoreStoreEditContactImport } from './routes/(app)/(store)/store/edit/contact'
import { Route as appstoreStoreEditBusinessImport } from './routes/(app)/(store)/store/edit/business'
import { Route as appstoreStoreEditAddressImport } from './routes/(app)/(store)/store/edit/address'
import { Route as appstoreCustomerUpdateCustomerSellerBuyerRouteMappingIdImport } from './routes/(app)/(store)/customer/update-customer/$sellerBuyerRouteMappingId'
import { Route as appstoreSalesOrderIdReturnIndexImport } from './routes/(app)/(store)/sales/$orderId/return/index'
import { Route as appstoreSalesOrderIdEditIndexImport } from './routes/(app)/(store)/sales/$orderId/edit/index'
import { Route as appstoreProductProductIdUpdateIndexImport } from './routes/(app)/(store)/product/$productId/update/index'
import { Route as appstoreExpensePurchaseCreateIndexImport } from './routes/(app)/(store)/expense/purchase/create/index'

// Create Virtual Routes

const appstoreExpenseExpenseCategoryIdCreateLazyImport = createFileRoute(
  '/(app)/(store)/expense/$expenseCategoryId/create',
)()
const appstoreExpenseExpenseCategoryIdViewLazyImport = createFileRoute(
  '/(app)/(store)/expense/$expenseCategoryId/$view',
)()

// Create/Update Routes

const TermsOfServiceRoute = TermsOfServiceImport.update({
  id: '/terms-of-service',
  path: '/terms-of-service',
  getParentRoute: () => rootRoute,
} as any)

const SupportRoute = SupportImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRoute,
} as any)

const PrivacyPolicyRoute = PrivacyPolicyImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRoute,
} as any)

const HelpCenterRoute = HelpCenterImport.update({
  id: '/help-center',
  path: '/help-center',
  getParentRoute: () => rootRoute,
} as any)

const ContactRoute = ContactImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRoute,
} as any)

const BlogRoute = BlogImport.update({
  id: '/blog',
  path: '/blog',
  getParentRoute: () => rootRoute,
} as any)

const AboutRoute = AboutImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRoute,
} as any)

const onboardingRouteRoute = onboardingRouteImport.update({
  id: '/(onboarding)',
  getParentRoute: () => rootRoute,
} as any)

const authRouteRoute = authRouteImport.update({
  id: '/(auth)',
  getParentRoute: () => rootRoute,
} as any)

const appRouteRoute = appRouteImport.update({
  id: '/(app)',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const authTermsAndConditionsRoute = authTermsAndConditionsImport.update({
  id: '/terms-and-conditions',
  path: '/terms-and-conditions',
  getParentRoute: () => authRouteRoute,
} as any)

const authPrivacyRoute = authPrivacyImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => authRouteRoute,
} as any)

const authLoginRoute = authLoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => authRouteRoute,
} as any)

const authGetAppRoute = authGetAppImport.update({
  id: '/get-app',
  path: '/get-app',
  getParentRoute: () => authRouteRoute,
} as any)

const appDashboardIndexRoute = appDashboardIndexImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => appRouteRoute,
} as any)

const onboardingStoreCreateRoute = onboardingStoreCreateImport.update({
  id: '/store/create',
  path: '/store/create',
  getParentRoute: () => onboardingRouteRoute,
} as any)

const appuserStoreIndexRoute = appuserStoreIndexImport.update({
  id: '/(user)/store/',
  path: '/store/',
  getParentRoute: () => appRouteRoute,
} as any)

const appstoreStaffIndexRoute = appstoreStaffIndexImport.update({
  id: '/(store)/staff/',
  path: '/staff/',
  getParentRoute: () => appRouteRoute,
} as any)

const appstoreSettingsIndexRoute = appstoreSettingsIndexImport.update({
  id: '/(store)/settings/',
  path: '/settings/',
  getParentRoute: () => appRouteRoute,
} as any)

const appstoreSalesIndexRoute = appstoreSalesIndexImport.update({
  id: '/(store)/sales/',
  path: '/sales/',
  getParentRoute: () => appRouteRoute,
} as any)

const appstoreProductIndexRoute = appstoreProductIndexImport.update({
  id: '/(store)/product/',
  path: '/product/',
  getParentRoute: () => appRouteRoute,
} as any)

const appstoreOrderIndexRoute = appstoreOrderIndexImport.update({
  id: '/(store)/order/',
  path: '/order/',
  getParentRoute: () => appRouteRoute,
} as any)

const appstoreExpenseIndexRoute = appstoreExpenseIndexImport.update({
  id: '/(store)/expense/',
  path: '/expense/',
  getParentRoute: () => appRouteRoute,
} as any)

const appstoreCustomerIndexRoute = appstoreCustomerIndexImport.update({
  id: '/(store)/customer/',
  path: '/customer/',
  getParentRoute: () => appRouteRoute,
} as any)

const appstoreSalesCreateIndexRoute = appstoreSalesCreateIndexImport.update({
  id: '/(store)/sales/create/',
  path: '/sales/create/',
  getParentRoute: () => appRouteRoute,
} as any)

const appstoreSalesOrderIdIndexRoute = appstoreSalesOrderIdIndexImport.update({
  id: '/(store)/sales/$orderId/',
  path: '/sales/$orderId/',
  getParentRoute: () => appRouteRoute,
} as any)

const appstoreProductAddProductIndexRoute =
  appstoreProductAddProductIndexImport.update({
    id: '/(store)/product/add-product/',
    path: '/product/add-product/',
    getParentRoute: () => appRouteRoute,
  } as any)

const appstoreProductProductIdIndexRoute =
  appstoreProductProductIdIndexImport.update({
    id: '/(store)/product/$productId/',
    path: '/product/$productId/',
    getParentRoute: () => appRouteRoute,
  } as any)

const appstoreOrderNewOrderIndexRoute = appstoreOrderNewOrderIndexImport.update(
  {
    id: '/(store)/order/newOrder/',
    path: '/order/newOrder/',
    getParentRoute: () => appRouteRoute,
  } as any,
)

const appstoreOrderOrderIdIndexRoute = appstoreOrderOrderIdIndexImport.update({
  id: '/(store)/order/$orderId/',
  path: '/order/$orderId/',
  getParentRoute: () => appRouteRoute,
} as any)

const appstoreExpensePurchaseIndexRoute =
  appstoreExpensePurchaseIndexImport.update({
    id: '/(store)/expense/purchase/',
    path: '/expense/purchase/',
    getParentRoute: () => appRouteRoute,
  } as any)

const appstoreExpenseExpenseCategoryIdIndexRoute =
  appstoreExpenseExpenseCategoryIdIndexImport.update({
    id: '/(store)/expense/$expenseCategoryId/',
    path: '/expense/$expenseCategoryId/',
    getParentRoute: () => appRouteRoute,
  } as any)

const appstoreCustomerAddCustomerIndexRoute =
  appstoreCustomerAddCustomerIndexImport.update({
    id: '/(store)/customer/add-customer/',
    path: '/customer/add-customer/',
    getParentRoute: () => appRouteRoute,
  } as any)

const appstoreExpenseExpenseCategoryIdCreateLazyRoute =
  appstoreExpenseExpenseCategoryIdCreateLazyImport
    .update({
      id: '/(store)/expense/$expenseCategoryId/create',
      path: '/expense/$expenseCategoryId/create',
      getParentRoute: () => appRouteRoute,
    } as any)
    .lazy(() =>
      import(
        './routes/(app)/(store)/expense/$expenseCategoryId/create.lazy'
      ).then((d) => d.Route),
    )

const appstoreExpenseExpenseCategoryIdViewLazyRoute =
  appstoreExpenseExpenseCategoryIdViewLazyImport
    .update({
      id: '/(store)/expense/$expenseCategoryId/$view',
      path: '/expense/$expenseCategoryId/$view',
      getParentRoute: () => appRouteRoute,
    } as any)
    .lazy(() =>
      import(
        './routes/(app)/(store)/expense/$expenseCategoryId/$view.lazy'
      ).then((d) => d.Route),
    )

const appstoreStoreEditContactRoute = appstoreStoreEditContactImport.update({
  id: '/(store)/store/edit/contact',
  path: '/store/edit/contact',
  getParentRoute: () => appRouteRoute,
} as any)

const appstoreStoreEditBusinessRoute = appstoreStoreEditBusinessImport.update({
  id: '/(store)/store/edit/business',
  path: '/store/edit/business',
  getParentRoute: () => appRouteRoute,
} as any)

const appstoreStoreEditAddressRoute = appstoreStoreEditAddressImport.update({
  id: '/(store)/store/edit/address',
  path: '/store/edit/address',
  getParentRoute: () => appRouteRoute,
} as any)

const appstoreCustomerUpdateCustomerSellerBuyerRouteMappingIdRoute =
  appstoreCustomerUpdateCustomerSellerBuyerRouteMappingIdImport.update({
    id: '/(store)/customer/update-customer/$sellerBuyerRouteMappingId',
    path: '/customer/update-customer/$sellerBuyerRouteMappingId',
    getParentRoute: () => appRouteRoute,
  } as any)

const appstoreSalesOrderIdReturnIndexRoute =
  appstoreSalesOrderIdReturnIndexImport.update({
    id: '/(store)/sales/$orderId/return/',
    path: '/sales/$orderId/return/',
    getParentRoute: () => appRouteRoute,
  } as any)

const appstoreSalesOrderIdEditIndexRoute =
  appstoreSalesOrderIdEditIndexImport.update({
    id: '/(store)/sales/$orderId/edit/',
    path: '/sales/$orderId/edit/',
    getParentRoute: () => appRouteRoute,
  } as any)

const appstoreProductProductIdUpdateIndexRoute =
  appstoreProductProductIdUpdateIndexImport.update({
    id: '/(store)/product/$productId/update/',
    path: '/product/$productId/update/',
    getParentRoute: () => appRouteRoute,
  } as any)

const appstoreExpensePurchaseCreateIndexRoute =
  appstoreExpensePurchaseCreateIndexImport.update({
    id: '/(store)/expense/purchase/create/',
    path: '/expense/purchase/create/',
    getParentRoute: () => appRouteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/(app)': {
      id: '/(app)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof appRouteImport
      parentRoute: typeof rootRoute
    }
    '/(auth)': {
      id: '/(auth)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof authRouteImport
      parentRoute: typeof rootRoute
    }
    '/(onboarding)': {
      id: '/(onboarding)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof onboardingRouteImport
      parentRoute: typeof rootRoute
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutImport
      parentRoute: typeof rootRoute
    }
    '/blog': {
      id: '/blog'
      path: '/blog'
      fullPath: '/blog'
      preLoaderRoute: typeof BlogImport
      parentRoute: typeof rootRoute
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactImport
      parentRoute: typeof rootRoute
    }
    '/help-center': {
      id: '/help-center'
      path: '/help-center'
      fullPath: '/help-center'
      preLoaderRoute: typeof HelpCenterImport
      parentRoute: typeof rootRoute
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyImport
      parentRoute: typeof rootRoute
    }
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportImport
      parentRoute: typeof rootRoute
    }
    '/terms-of-service': {
      id: '/terms-of-service'
      path: '/terms-of-service'
      fullPath: '/terms-of-service'
      preLoaderRoute: typeof TermsOfServiceImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/get-app': {
      id: '/(auth)/get-app'
      path: '/get-app'
      fullPath: '/get-app'
      preLoaderRoute: typeof authGetAppImport
      parentRoute: typeof authRouteImport
    }
    '/(auth)/login': {
      id: '/(auth)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authLoginImport
      parentRoute: typeof authRouteImport
    }
    '/(auth)/privacy': {
      id: '/(auth)/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof authPrivacyImport
      parentRoute: typeof authRouteImport
    }
    '/(auth)/terms-and-conditions': {
      id: '/(auth)/terms-and-conditions'
      path: '/terms-and-conditions'
      fullPath: '/terms-and-conditions'
      preLoaderRoute: typeof authTermsAndConditionsImport
      parentRoute: typeof authRouteImport
    }
    '/(onboarding)/store/create': {
      id: '/(onboarding)/store/create'
      path: '/store/create'
      fullPath: '/store/create'
      preLoaderRoute: typeof onboardingStoreCreateImport
      parentRoute: typeof onboardingRouteImport
    }
    '/(app)/dashboard/': {
      id: '/(app)/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof appDashboardIndexImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/(store)/customer/': {
      id: '/(app)/(store)/customer/'
      path: '/customer'
      fullPath: '/customer'
      preLoaderRoute: typeof appstoreCustomerIndexImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/(store)/expense/': {
      id: '/(app)/(store)/expense/'
      path: '/expense'
      fullPath: '/expense'
      preLoaderRoute: typeof appstoreExpenseIndexImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/(store)/order/': {
      id: '/(app)/(store)/order/'
      path: '/order'
      fullPath: '/order'
      preLoaderRoute: typeof appstoreOrderIndexImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/(store)/product/': {
      id: '/(app)/(store)/product/'
      path: '/product'
      fullPath: '/product'
      preLoaderRoute: typeof appstoreProductIndexImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/(store)/sales/': {
      id: '/(app)/(store)/sales/'
      path: '/sales'
      fullPath: '/sales'
      preLoaderRoute: typeof appstoreSalesIndexImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/(store)/settings/': {
      id: '/(app)/(store)/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof appstoreSettingsIndexImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/(store)/staff/': {
      id: '/(app)/(store)/staff/'
      path: '/staff'
      fullPath: '/staff'
      preLoaderRoute: typeof appstoreStaffIndexImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/(user)/store/': {
      id: '/(app)/(user)/store/'
      path: '/store'
      fullPath: '/store'
      preLoaderRoute: typeof appuserStoreIndexImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/(store)/customer/update-customer/$sellerBuyerRouteMappingId': {
      id: '/(app)/(store)/customer/update-customer/$sellerBuyerRouteMappingId'
      path: '/customer/update-customer/$sellerBuyerRouteMappingId'
      fullPath: '/customer/update-customer/$sellerBuyerRouteMappingId'
      preLoaderRoute: typeof appstoreCustomerUpdateCustomerSellerBuyerRouteMappingIdImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/(store)/store/edit/address': {
      id: '/(app)/(store)/store/edit/address'
      path: '/store/edit/address'
      fullPath: '/store/edit/address'
      preLoaderRoute: typeof appstoreStoreEditAddressImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/(store)/store/edit/business': {
      id: '/(app)/(store)/store/edit/business'
      path: '/store/edit/business'
      fullPath: '/store/edit/business'
      preLoaderRoute: typeof appstoreStoreEditBusinessImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/(store)/store/edit/contact': {
      id: '/(app)/(store)/store/edit/contact'
      path: '/store/edit/contact'
      fullPath: '/store/edit/contact'
      preLoaderRoute: typeof appstoreStoreEditContactImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/(store)/expense/$expenseCategoryId/$view': {
      id: '/(app)/(store)/expense/$expenseCategoryId/$view'
      path: '/expense/$expenseCategoryId/$view'
      fullPath: '/expense/$expenseCategoryId/$view'
      preLoaderRoute: typeof appstoreExpenseExpenseCategoryIdViewLazyImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/(store)/expense/$expenseCategoryId/create': {
      id: '/(app)/(store)/expense/$expenseCategoryId/create'
      path: '/expense/$expenseCategoryId/create'
      fullPath: '/expense/$expenseCategoryId/create'
      preLoaderRoute: typeof appstoreExpenseExpenseCategoryIdCreateLazyImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/(store)/customer/add-customer/': {
      id: '/(app)/(store)/customer/add-customer/'
      path: '/customer/add-customer'
      fullPath: '/customer/add-customer'
      preLoaderRoute: typeof appstoreCustomerAddCustomerIndexImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/(store)/expense/$expenseCategoryId/': {
      id: '/(app)/(store)/expense/$expenseCategoryId/'
      path: '/expense/$expenseCategoryId'
      fullPath: '/expense/$expenseCategoryId'
      preLoaderRoute: typeof appstoreExpenseExpenseCategoryIdIndexImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/(store)/expense/purchase/': {
      id: '/(app)/(store)/expense/purchase/'
      path: '/expense/purchase'
      fullPath: '/expense/purchase'
      preLoaderRoute: typeof appstoreExpensePurchaseIndexImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/(store)/order/$orderId/': {
      id: '/(app)/(store)/order/$orderId/'
      path: '/order/$orderId'
      fullPath: '/order/$orderId'
      preLoaderRoute: typeof appstoreOrderOrderIdIndexImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/(store)/order/newOrder/': {
      id: '/(app)/(store)/order/newOrder/'
      path: '/order/newOrder'
      fullPath: '/order/newOrder'
      preLoaderRoute: typeof appstoreOrderNewOrderIndexImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/(store)/product/$productId/': {
      id: '/(app)/(store)/product/$productId/'
      path: '/product/$productId'
      fullPath: '/product/$productId'
      preLoaderRoute: typeof appstoreProductProductIdIndexImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/(store)/product/add-product/': {
      id: '/(app)/(store)/product/add-product/'
      path: '/product/add-product'
      fullPath: '/product/add-product'
      preLoaderRoute: typeof appstoreProductAddProductIndexImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/(store)/sales/$orderId/': {
      id: '/(app)/(store)/sales/$orderId/'
      path: '/sales/$orderId'
      fullPath: '/sales/$orderId'
      preLoaderRoute: typeof appstoreSalesOrderIdIndexImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/(store)/sales/create/': {
      id: '/(app)/(store)/sales/create/'
      path: '/sales/create'
      fullPath: '/sales/create'
      preLoaderRoute: typeof appstoreSalesCreateIndexImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/(store)/expense/purchase/create/': {
      id: '/(app)/(store)/expense/purchase/create/'
      path: '/expense/purchase/create'
      fullPath: '/expense/purchase/create'
      preLoaderRoute: typeof appstoreExpensePurchaseCreateIndexImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/(store)/product/$productId/update/': {
      id: '/(app)/(store)/product/$productId/update/'
      path: '/product/$productId/update'
      fullPath: '/product/$productId/update'
      preLoaderRoute: typeof appstoreProductProductIdUpdateIndexImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/(store)/sales/$orderId/edit/': {
      id: '/(app)/(store)/sales/$orderId/edit/'
      path: '/sales/$orderId/edit'
      fullPath: '/sales/$orderId/edit'
      preLoaderRoute: typeof appstoreSalesOrderIdEditIndexImport
      parentRoute: typeof appRouteImport
    }
    '/(app)/(store)/sales/$orderId/return/': {
      id: '/(app)/(store)/sales/$orderId/return/'
      path: '/sales/$orderId/return'
      fullPath: '/sales/$orderId/return'
      preLoaderRoute: typeof appstoreSalesOrderIdReturnIndexImport
      parentRoute: typeof appRouteImport
    }
  }
}

// Create and export the route tree

interface appRouteRouteChildren {
  appDashboardIndexRoute: typeof appDashboardIndexRoute
  appstoreCustomerIndexRoute: typeof appstoreCustomerIndexRoute
  appstoreExpenseIndexRoute: typeof appstoreExpenseIndexRoute
  appstoreOrderIndexRoute: typeof appstoreOrderIndexRoute
  appstoreProductIndexRoute: typeof appstoreProductIndexRoute
  appstoreSalesIndexRoute: typeof appstoreSalesIndexRoute
  appstoreSettingsIndexRoute: typeof appstoreSettingsIndexRoute
  appstoreStaffIndexRoute: typeof appstoreStaffIndexRoute
  appuserStoreIndexRoute: typeof appuserStoreIndexRoute
  appstoreCustomerUpdateCustomerSellerBuyerRouteMappingIdRoute: typeof appstoreCustomerUpdateCustomerSellerBuyerRouteMappingIdRoute
  appstoreStoreEditAddressRoute: typeof appstoreStoreEditAddressRoute
  appstoreStoreEditBusinessRoute: typeof appstoreStoreEditBusinessRoute
  appstoreStoreEditContactRoute: typeof appstoreStoreEditContactRoute
  appstoreExpenseExpenseCategoryIdViewLazyRoute: typeof appstoreExpenseExpenseCategoryIdViewLazyRoute
  appstoreExpenseExpenseCategoryIdCreateLazyRoute: typeof appstoreExpenseExpenseCategoryIdCreateLazyRoute
  appstoreCustomerAddCustomerIndexRoute: typeof appstoreCustomerAddCustomerIndexRoute
  appstoreExpenseExpenseCategoryIdIndexRoute: typeof appstoreExpenseExpenseCategoryIdIndexRoute
  appstoreExpensePurchaseIndexRoute: typeof appstoreExpensePurchaseIndexRoute
  appstoreOrderOrderIdIndexRoute: typeof appstoreOrderOrderIdIndexRoute
  appstoreOrderNewOrderIndexRoute: typeof appstoreOrderNewOrderIndexRoute
  appstoreProductProductIdIndexRoute: typeof appstoreProductProductIdIndexRoute
  appstoreProductAddProductIndexRoute: typeof appstoreProductAddProductIndexRoute
  appstoreSalesOrderIdIndexRoute: typeof appstoreSalesOrderIdIndexRoute
  appstoreSalesCreateIndexRoute: typeof appstoreSalesCreateIndexRoute
  appstoreExpensePurchaseCreateIndexRoute: typeof appstoreExpensePurchaseCreateIndexRoute
  appstoreProductProductIdUpdateIndexRoute: typeof appstoreProductProductIdUpdateIndexRoute
  appstoreSalesOrderIdEditIndexRoute: typeof appstoreSalesOrderIdEditIndexRoute
  appstoreSalesOrderIdReturnIndexRoute: typeof appstoreSalesOrderIdReturnIndexRoute
}

const appRouteRouteChildren: appRouteRouteChildren = {
  appDashboardIndexRoute: appDashboardIndexRoute,
  appstoreCustomerIndexRoute: appstoreCustomerIndexRoute,
  appstoreExpenseIndexRoute: appstoreExpenseIndexRoute,
  appstoreOrderIndexRoute: appstoreOrderIndexRoute,
  appstoreProductIndexRoute: appstoreProductIndexRoute,
  appstoreSalesIndexRoute: appstoreSalesIndexRoute,
  appstoreSettingsIndexRoute: appstoreSettingsIndexRoute,
  appstoreStaffIndexRoute: appstoreStaffIndexRoute,
  appuserStoreIndexRoute: appuserStoreIndexRoute,
  appstoreCustomerUpdateCustomerSellerBuyerRouteMappingIdRoute:
    appstoreCustomerUpdateCustomerSellerBuyerRouteMappingIdRoute,
  appstoreStoreEditAddressRoute: appstoreStoreEditAddressRoute,
  appstoreStoreEditBusinessRoute: appstoreStoreEditBusinessRoute,
  appstoreStoreEditContactRoute: appstoreStoreEditContactRoute,
  appstoreExpenseExpenseCategoryIdViewLazyRoute:
    appstoreExpenseExpenseCategoryIdViewLazyRoute,
  appstoreExpenseExpenseCategoryIdCreateLazyRoute:
    appstoreExpenseExpenseCategoryIdCreateLazyRoute,
  appstoreCustomerAddCustomerIndexRoute: appstoreCustomerAddCustomerIndexRoute,
  appstoreExpenseExpenseCategoryIdIndexRoute:
    appstoreExpenseExpenseCategoryIdIndexRoute,
  appstoreExpensePurchaseIndexRoute: appstoreExpensePurchaseIndexRoute,
  appstoreOrderOrderIdIndexRoute: appstoreOrderOrderIdIndexRoute,
  appstoreOrderNewOrderIndexRoute: appstoreOrderNewOrderIndexRoute,
  appstoreProductProductIdIndexRoute: appstoreProductProductIdIndexRoute,
  appstoreProductAddProductIndexRoute: appstoreProductAddProductIndexRoute,
  appstoreSalesOrderIdIndexRoute: appstoreSalesOrderIdIndexRoute,
  appstoreSalesCreateIndexRoute: appstoreSalesCreateIndexRoute,
  appstoreExpensePurchaseCreateIndexRoute:
    appstoreExpensePurchaseCreateIndexRoute,
  appstoreProductProductIdUpdateIndexRoute:
    appstoreProductProductIdUpdateIndexRoute,
  appstoreSalesOrderIdEditIndexRoute: appstoreSalesOrderIdEditIndexRoute,
  appstoreSalesOrderIdReturnIndexRoute: appstoreSalesOrderIdReturnIndexRoute,
}

const appRouteRouteWithChildren = appRouteRoute._addFileChildren(
  appRouteRouteChildren,
)

interface authRouteRouteChildren {
  authGetAppRoute: typeof authGetAppRoute
  authLoginRoute: typeof authLoginRoute
  authPrivacyRoute: typeof authPrivacyRoute
  authTermsAndConditionsRoute: typeof authTermsAndConditionsRoute
}

const authRouteRouteChildren: authRouteRouteChildren = {
  authGetAppRoute: authGetAppRoute,
  authLoginRoute: authLoginRoute,
  authPrivacyRoute: authPrivacyRoute,
  authTermsAndConditionsRoute: authTermsAndConditionsRoute,
}

const authRouteRouteWithChildren = authRouteRoute._addFileChildren(
  authRouteRouteChildren,
)

interface onboardingRouteRouteChildren {
  onboardingStoreCreateRoute: typeof onboardingStoreCreateRoute
}

const onboardingRouteRouteChildren: onboardingRouteRouteChildren = {
  onboardingStoreCreateRoute: onboardingStoreCreateRoute,
}

const onboardingRouteRouteWithChildren = onboardingRouteRoute._addFileChildren(
  onboardingRouteRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof onboardingRouteRouteWithChildren
  '/about': typeof AboutRoute
  '/blog': typeof BlogRoute
  '/contact': typeof ContactRoute
  '/help-center': typeof HelpCenterRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/support': typeof SupportRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/get-app': typeof authGetAppRoute
  '/login': typeof authLoginRoute
  '/privacy': typeof authPrivacyRoute
  '/terms-and-conditions': typeof authTermsAndConditionsRoute
  '/store/create': typeof onboardingStoreCreateRoute
  '/dashboard': typeof appDashboardIndexRoute
  '/customer': typeof appstoreCustomerIndexRoute
  '/expense': typeof appstoreExpenseIndexRoute
  '/order': typeof appstoreOrderIndexRoute
  '/product': typeof appstoreProductIndexRoute
  '/sales': typeof appstoreSalesIndexRoute
  '/settings': typeof appstoreSettingsIndexRoute
  '/staff': typeof appstoreStaffIndexRoute
  '/store': typeof appuserStoreIndexRoute
  '/customer/update-customer/$sellerBuyerRouteMappingId': typeof appstoreCustomerUpdateCustomerSellerBuyerRouteMappingIdRoute
  '/store/edit/address': typeof appstoreStoreEditAddressRoute
  '/store/edit/business': typeof appstoreStoreEditBusinessRoute
  '/store/edit/contact': typeof appstoreStoreEditContactRoute
  '/expense/$expenseCategoryId/$view': typeof appstoreExpenseExpenseCategoryIdViewLazyRoute
  '/expense/$expenseCategoryId/create': typeof appstoreExpenseExpenseCategoryIdCreateLazyRoute
  '/customer/add-customer': typeof appstoreCustomerAddCustomerIndexRoute
  '/expense/$expenseCategoryId': typeof appstoreExpenseExpenseCategoryIdIndexRoute
  '/expense/purchase': typeof appstoreExpensePurchaseIndexRoute
  '/order/$orderId': typeof appstoreOrderOrderIdIndexRoute
  '/order/newOrder': typeof appstoreOrderNewOrderIndexRoute
  '/product/$productId': typeof appstoreProductProductIdIndexRoute
  '/product/add-product': typeof appstoreProductAddProductIndexRoute
  '/sales/$orderId': typeof appstoreSalesOrderIdIndexRoute
  '/sales/create': typeof appstoreSalesCreateIndexRoute
  '/expense/purchase/create': typeof appstoreExpensePurchaseCreateIndexRoute
  '/product/$productId/update': typeof appstoreProductProductIdUpdateIndexRoute
  '/sales/$orderId/edit': typeof appstoreSalesOrderIdEditIndexRoute
  '/sales/$orderId/return': typeof appstoreSalesOrderIdReturnIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof onboardingRouteRouteWithChildren
  '/about': typeof AboutRoute
  '/blog': typeof BlogRoute
  '/contact': typeof ContactRoute
  '/help-center': typeof HelpCenterRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/support': typeof SupportRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/get-app': typeof authGetAppRoute
  '/login': typeof authLoginRoute
  '/privacy': typeof authPrivacyRoute
  '/terms-and-conditions': typeof authTermsAndConditionsRoute
  '/store/create': typeof onboardingStoreCreateRoute
  '/dashboard': typeof appDashboardIndexRoute
  '/customer': typeof appstoreCustomerIndexRoute
  '/expense': typeof appstoreExpenseIndexRoute
  '/order': typeof appstoreOrderIndexRoute
  '/product': typeof appstoreProductIndexRoute
  '/sales': typeof appstoreSalesIndexRoute
  '/settings': typeof appstoreSettingsIndexRoute
  '/staff': typeof appstoreStaffIndexRoute
  '/store': typeof appuserStoreIndexRoute
  '/customer/update-customer/$sellerBuyerRouteMappingId': typeof appstoreCustomerUpdateCustomerSellerBuyerRouteMappingIdRoute
  '/store/edit/address': typeof appstoreStoreEditAddressRoute
  '/store/edit/business': typeof appstoreStoreEditBusinessRoute
  '/store/edit/contact': typeof appstoreStoreEditContactRoute
  '/expense/$expenseCategoryId/$view': typeof appstoreExpenseExpenseCategoryIdViewLazyRoute
  '/expense/$expenseCategoryId/create': typeof appstoreExpenseExpenseCategoryIdCreateLazyRoute
  '/customer/add-customer': typeof appstoreCustomerAddCustomerIndexRoute
  '/expense/$expenseCategoryId': typeof appstoreExpenseExpenseCategoryIdIndexRoute
  '/expense/purchase': typeof appstoreExpensePurchaseIndexRoute
  '/order/$orderId': typeof appstoreOrderOrderIdIndexRoute
  '/order/newOrder': typeof appstoreOrderNewOrderIndexRoute
  '/product/$productId': typeof appstoreProductProductIdIndexRoute
  '/product/add-product': typeof appstoreProductAddProductIndexRoute
  '/sales/$orderId': typeof appstoreSalesOrderIdIndexRoute
  '/sales/create': typeof appstoreSalesCreateIndexRoute
  '/expense/purchase/create': typeof appstoreExpensePurchaseCreateIndexRoute
  '/product/$productId/update': typeof appstoreProductProductIdUpdateIndexRoute
  '/sales/$orderId/edit': typeof appstoreSalesOrderIdEditIndexRoute
  '/sales/$orderId/return': typeof appstoreSalesOrderIdReturnIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/(app)': typeof appRouteRouteWithChildren
  '/(auth)': typeof authRouteRouteWithChildren
  '/(onboarding)': typeof onboardingRouteRouteWithChildren
  '/about': typeof AboutRoute
  '/blog': typeof BlogRoute
  '/contact': typeof ContactRoute
  '/help-center': typeof HelpCenterRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/support': typeof SupportRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/(auth)/get-app': typeof authGetAppRoute
  '/(auth)/login': typeof authLoginRoute
  '/(auth)/privacy': typeof authPrivacyRoute
  '/(auth)/terms-and-conditions': typeof authTermsAndConditionsRoute
  '/(onboarding)/store/create': typeof onboardingStoreCreateRoute
  '/(app)/dashboard/': typeof appDashboardIndexRoute
  '/(app)/(store)/customer/': typeof appstoreCustomerIndexRoute
  '/(app)/(store)/expense/': typeof appstoreExpenseIndexRoute
  '/(app)/(store)/order/': typeof appstoreOrderIndexRoute
  '/(app)/(store)/product/': typeof appstoreProductIndexRoute
  '/(app)/(store)/sales/': typeof appstoreSalesIndexRoute
  '/(app)/(store)/settings/': typeof appstoreSettingsIndexRoute
  '/(app)/(store)/staff/': typeof appstoreStaffIndexRoute
  '/(app)/(user)/store/': typeof appuserStoreIndexRoute
  '/(app)/(store)/customer/update-customer/$sellerBuyerRouteMappingId': typeof appstoreCustomerUpdateCustomerSellerBuyerRouteMappingIdRoute
  '/(app)/(store)/store/edit/address': typeof appstoreStoreEditAddressRoute
  '/(app)/(store)/store/edit/business': typeof appstoreStoreEditBusinessRoute
  '/(app)/(store)/store/edit/contact': typeof appstoreStoreEditContactRoute
  '/(app)/(store)/expense/$expenseCategoryId/$view': typeof appstoreExpenseExpenseCategoryIdViewLazyRoute
  '/(app)/(store)/expense/$expenseCategoryId/create': typeof appstoreExpenseExpenseCategoryIdCreateLazyRoute
  '/(app)/(store)/customer/add-customer/': typeof appstoreCustomerAddCustomerIndexRoute
  '/(app)/(store)/expense/$expenseCategoryId/': typeof appstoreExpenseExpenseCategoryIdIndexRoute
  '/(app)/(store)/expense/purchase/': typeof appstoreExpensePurchaseIndexRoute
  '/(app)/(store)/order/$orderId/': typeof appstoreOrderOrderIdIndexRoute
  '/(app)/(store)/order/newOrder/': typeof appstoreOrderNewOrderIndexRoute
  '/(app)/(store)/product/$productId/': typeof appstoreProductProductIdIndexRoute
  '/(app)/(store)/product/add-product/': typeof appstoreProductAddProductIndexRoute
  '/(app)/(store)/sales/$orderId/': typeof appstoreSalesOrderIdIndexRoute
  '/(app)/(store)/sales/create/': typeof appstoreSalesCreateIndexRoute
  '/(app)/(store)/expense/purchase/create/': typeof appstoreExpensePurchaseCreateIndexRoute
  '/(app)/(store)/product/$productId/update/': typeof appstoreProductProductIdUpdateIndexRoute
  '/(app)/(store)/sales/$orderId/edit/': typeof appstoreSalesOrderIdEditIndexRoute
  '/(app)/(store)/sales/$orderId/return/': typeof appstoreSalesOrderIdReturnIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/blog'
    | '/contact'
    | '/help-center'
    | '/privacy-policy'
    | '/support'
    | '/terms-of-service'
    | '/get-app'
    | '/login'
    | '/privacy'
    | '/terms-and-conditions'
    | '/store/create'
    | '/dashboard'
    | '/customer'
    | '/expense'
    | '/order'
    | '/product'
    | '/sales'
    | '/settings'
    | '/staff'
    | '/store'
    | '/customer/update-customer/$sellerBuyerRouteMappingId'
    | '/store/edit/address'
    | '/store/edit/business'
    | '/store/edit/contact'
    | '/expense/$expenseCategoryId/$view'
    | '/expense/$expenseCategoryId/create'
    | '/customer/add-customer'
    | '/expense/$expenseCategoryId'
    | '/expense/purchase'
    | '/order/$orderId'
    | '/order/newOrder'
    | '/product/$productId'
    | '/product/add-product'
    | '/sales/$orderId'
    | '/sales/create'
    | '/expense/purchase/create'
    | '/product/$productId/update'
    | '/sales/$orderId/edit'
    | '/sales/$orderId/return'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/blog'
    | '/contact'
    | '/help-center'
    | '/privacy-policy'
    | '/support'
    | '/terms-of-service'
    | '/get-app'
    | '/login'
    | '/privacy'
    | '/terms-and-conditions'
    | '/store/create'
    | '/dashboard'
    | '/customer'
    | '/expense'
    | '/order'
    | '/product'
    | '/sales'
    | '/settings'
    | '/staff'
    | '/store'
    | '/customer/update-customer/$sellerBuyerRouteMappingId'
    | '/store/edit/address'
    | '/store/edit/business'
    | '/store/edit/contact'
    | '/expense/$expenseCategoryId/$view'
    | '/expense/$expenseCategoryId/create'
    | '/customer/add-customer'
    | '/expense/$expenseCategoryId'
    | '/expense/purchase'
    | '/order/$orderId'
    | '/order/newOrder'
    | '/product/$productId'
    | '/product/add-product'
    | '/sales/$orderId'
    | '/sales/create'
    | '/expense/purchase/create'
    | '/product/$productId/update'
    | '/sales/$orderId/edit'
    | '/sales/$orderId/return'
  id:
    | '__root__'
    | '/'
    | '/(app)'
    | '/(auth)'
    | '/(onboarding)'
    | '/about'
    | '/blog'
    | '/contact'
    | '/help-center'
    | '/privacy-policy'
    | '/support'
    | '/terms-of-service'
    | '/(auth)/get-app'
    | '/(auth)/login'
    | '/(auth)/privacy'
    | '/(auth)/terms-and-conditions'
    | '/(onboarding)/store/create'
    | '/(app)/dashboard/'
    | '/(app)/(store)/customer/'
    | '/(app)/(store)/expense/'
    | '/(app)/(store)/order/'
    | '/(app)/(store)/product/'
    | '/(app)/(store)/sales/'
    | '/(app)/(store)/settings/'
    | '/(app)/(store)/staff/'
    | '/(app)/(user)/store/'
    | '/(app)/(store)/customer/update-customer/$sellerBuyerRouteMappingId'
    | '/(app)/(store)/store/edit/address'
    | '/(app)/(store)/store/edit/business'
    | '/(app)/(store)/store/edit/contact'
    | '/(app)/(store)/expense/$expenseCategoryId/$view'
    | '/(app)/(store)/expense/$expenseCategoryId/create'
    | '/(app)/(store)/customer/add-customer/'
    | '/(app)/(store)/expense/$expenseCategoryId/'
    | '/(app)/(store)/expense/purchase/'
    | '/(app)/(store)/order/$orderId/'
    | '/(app)/(store)/order/newOrder/'
    | '/(app)/(store)/product/$productId/'
    | '/(app)/(store)/product/add-product/'
    | '/(app)/(store)/sales/$orderId/'
    | '/(app)/(store)/sales/create/'
    | '/(app)/(store)/expense/purchase/create/'
    | '/(app)/(store)/product/$productId/update/'
    | '/(app)/(store)/sales/$orderId/edit/'
    | '/(app)/(store)/sales/$orderId/return/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  appRouteRoute: typeof appRouteRouteWithChildren
  authRouteRoute: typeof authRouteRouteWithChildren
  onboardingRouteRoute: typeof onboardingRouteRouteWithChildren
  AboutRoute: typeof AboutRoute
  BlogRoute: typeof BlogRoute
  ContactRoute: typeof ContactRoute
  HelpCenterRoute: typeof HelpCenterRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  SupportRoute: typeof SupportRoute
  TermsOfServiceRoute: typeof TermsOfServiceRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  appRouteRoute: appRouteRouteWithChildren,
  authRouteRoute: authRouteRouteWithChildren,
  onboardingRouteRoute: onboardingRouteRouteWithChildren,
  AboutRoute: AboutRoute,
  BlogRoute: BlogRoute,
  ContactRoute: ContactRoute,
  HelpCenterRoute: HelpCenterRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  SupportRoute: SupportRoute,
  TermsOfServiceRoute: TermsOfServiceRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/(app)",
        "/(auth)",
        "/(onboarding)",
        "/about",
        "/blog",
        "/contact",
        "/help-center",
        "/privacy-policy",
        "/support",
        "/terms-of-service"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/(app)": {
      "filePath": "(app)/route.tsx",
      "children": [
        "/(app)/dashboard/",
        "/(app)/(store)/customer/",
        "/(app)/(store)/expense/",
        "/(app)/(store)/order/",
        "/(app)/(store)/product/",
        "/(app)/(store)/sales/",
        "/(app)/(store)/settings/",
        "/(app)/(store)/staff/",
        "/(app)/(user)/store/",
        "/(app)/(store)/customer/update-customer/$sellerBuyerRouteMappingId",
        "/(app)/(store)/store/edit/address",
        "/(app)/(store)/store/edit/business",
        "/(app)/(store)/store/edit/contact",
        "/(app)/(store)/expense/$expenseCategoryId/$view",
        "/(app)/(store)/expense/$expenseCategoryId/create",
        "/(app)/(store)/customer/add-customer/",
        "/(app)/(store)/expense/$expenseCategoryId/",
        "/(app)/(store)/expense/purchase/",
        "/(app)/(store)/order/$orderId/",
        "/(app)/(store)/order/newOrder/",
        "/(app)/(store)/product/$productId/",
        "/(app)/(store)/product/add-product/",
        "/(app)/(store)/sales/$orderId/",
        "/(app)/(store)/sales/create/",
        "/(app)/(store)/expense/purchase/create/",
        "/(app)/(store)/product/$productId/update/",
        "/(app)/(store)/sales/$orderId/edit/",
        "/(app)/(store)/sales/$orderId/return/"
      ]
    },
    "/(auth)": {
      "filePath": "(auth)/route.tsx",
      "children": [
        "/(auth)/get-app",
        "/(auth)/login",
        "/(auth)/privacy",
        "/(auth)/terms-and-conditions"
      ]
    },
    "/(onboarding)": {
      "filePath": "(onboarding)/route.tsx",
      "children": [
        "/(onboarding)/store/create"
      ]
    },
    "/about": {
      "filePath": "about.tsx"
    },
    "/blog": {
      "filePath": "blog.tsx"
    },
    "/contact": {
      "filePath": "contact.tsx"
    },
    "/help-center": {
      "filePath": "help-center.tsx"
    },
    "/privacy-policy": {
      "filePath": "privacy-policy.tsx"
    },
    "/support": {
      "filePath": "support.tsx"
    },
    "/terms-of-service": {
      "filePath": "terms-of-service.tsx"
    },
    "/(auth)/get-app": {
      "filePath": "(auth)/get-app.tsx",
      "parent": "/(auth)"
    },
    "/(auth)/login": {
      "filePath": "(auth)/login.tsx",
      "parent": "/(auth)"
    },
    "/(auth)/privacy": {
      "filePath": "(auth)/privacy.tsx",
      "parent": "/(auth)"
    },
    "/(auth)/terms-and-conditions": {
      "filePath": "(auth)/terms-and-conditions.tsx",
      "parent": "/(auth)"
    },
    "/(onboarding)/store/create": {
      "filePath": "(onboarding)/store/create.tsx",
      "parent": "/(onboarding)"
    },
    "/(app)/dashboard/": {
      "filePath": "(app)/dashboard/index.tsx",
      "parent": "/(app)"
    },
    "/(app)/(store)/customer/": {
      "filePath": "(app)/(store)/customer/index.tsx",
      "parent": "/(app)"
    },
    "/(app)/(store)/expense/": {
      "filePath": "(app)/(store)/expense/index.tsx",
      "parent": "/(app)"
    },
    "/(app)/(store)/order/": {
      "filePath": "(app)/(store)/order/index.tsx",
      "parent": "/(app)"
    },
    "/(app)/(store)/product/": {
      "filePath": "(app)/(store)/product/index.tsx",
      "parent": "/(app)"
    },
    "/(app)/(store)/sales/": {
      "filePath": "(app)/(store)/sales/index.tsx",
      "parent": "/(app)"
    },
    "/(app)/(store)/settings/": {
      "filePath": "(app)/(store)/settings/index.tsx",
      "parent": "/(app)"
    },
    "/(app)/(store)/staff/": {
      "filePath": "(app)/(store)/staff/index.tsx",
      "parent": "/(app)"
    },
    "/(app)/(user)/store/": {
      "filePath": "(app)/(user)/store/index.tsx",
      "parent": "/(app)"
    },
    "/(app)/(store)/customer/update-customer/$sellerBuyerRouteMappingId": {
      "filePath": "(app)/(store)/customer/update-customer/$sellerBuyerRouteMappingId.tsx",
      "parent": "/(app)"
    },
    "/(app)/(store)/store/edit/address": {
      "filePath": "(app)/(store)/store/edit/address.tsx",
      "parent": "/(app)"
    },
    "/(app)/(store)/store/edit/business": {
      "filePath": "(app)/(store)/store/edit/business.tsx",
      "parent": "/(app)"
    },
    "/(app)/(store)/store/edit/contact": {
      "filePath": "(app)/(store)/store/edit/contact.tsx",
      "parent": "/(app)"
    },
    "/(app)/(store)/expense/$expenseCategoryId/$view": {
      "filePath": "(app)/(store)/expense/$expenseCategoryId/$view.lazy.tsx",
      "parent": "/(app)"
    },
    "/(app)/(store)/expense/$expenseCategoryId/create": {
      "filePath": "(app)/(store)/expense/$expenseCategoryId/create.lazy.tsx",
      "parent": "/(app)"
    },
    "/(app)/(store)/customer/add-customer/": {
      "filePath": "(app)/(store)/customer/add-customer/index.tsx",
      "parent": "/(app)"
    },
    "/(app)/(store)/expense/$expenseCategoryId/": {
      "filePath": "(app)/(store)/expense/$expenseCategoryId/index.tsx",
      "parent": "/(app)"
    },
    "/(app)/(store)/expense/purchase/": {
      "filePath": "(app)/(store)/expense/purchase/index.tsx",
      "parent": "/(app)"
    },
    "/(app)/(store)/order/$orderId/": {
      "filePath": "(app)/(store)/order/$orderId/index.tsx",
      "parent": "/(app)"
    },
    "/(app)/(store)/order/newOrder/": {
      "filePath": "(app)/(store)/order/newOrder/index.tsx",
      "parent": "/(app)"
    },
    "/(app)/(store)/product/$productId/": {
      "filePath": "(app)/(store)/product/$productId/index.tsx",
      "parent": "/(app)"
    },
    "/(app)/(store)/product/add-product/": {
      "filePath": "(app)/(store)/product/add-product/index.tsx",
      "parent": "/(app)"
    },
    "/(app)/(store)/sales/$orderId/": {
      "filePath": "(app)/(store)/sales/$orderId/index.tsx",
      "parent": "/(app)"
    },
    "/(app)/(store)/sales/create/": {
      "filePath": "(app)/(store)/sales/create/index.tsx",
      "parent": "/(app)"
    },
    "/(app)/(store)/expense/purchase/create/": {
      "filePath": "(app)/(store)/expense/purchase/create/index.tsx",
      "parent": "/(app)"
    },
    "/(app)/(store)/product/$productId/update/": {
      "filePath": "(app)/(store)/product/$productId/update/index.tsx",
      "parent": "/(app)"
    },
    "/(app)/(store)/sales/$orderId/edit/": {
      "filePath": "(app)/(store)/sales/$orderId/edit/index.tsx",
      "parent": "/(app)"
    },
    "/(app)/(store)/sales/$orderId/return/": {
      "filePath": "(app)/(store)/sales/$orderId/return/index.tsx",
      "parent": "/(app)"
    }
  }
}
ROUTE_MANIFEST_END */
